import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { SessionStorageService } from './session-storage.service';
import { LocalStorageKey } from '../models/frontend/local-storage.key';
import { merge, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class LocalStorageService implements OnDestroy {
    private readonly _uuid: string;
    private readonly sub: Subscription;

    private localStorageSubject: Subject<any>;

    constructor() {
        this.localStorageSubject = new Subject<any>();

        // observe 'id' and 'username'
        this._uuid = LocalStorageService._buildAndReturnUUID();

        this.sub = merge(SessionStorageService.username.observable, SessionStorageService.id.observable)
            .pipe(tap(() => LocalStorageService._buildAndReturnUUID()))
            .subscribe();
    }

    private static _buildAndReturnUUID() {
        const id = SessionStorageService.id.get();
        const username = SessionStorageService.username.get();
        if (id != null && username != null) {
            return btoa(`${id}${username}`);
        }
        return null;
    }

    ngOnDestroy(): void {
        if (this.sub != null) {
            this.sub.unsubscribe();
        }
    }

    localStorageObservable() {
        return this.localStorageSubject.asObservable();
    }

    setItem(key: LocalStorageKey, value: Object): void {
        if (key == null) {
            return;
        }
        let userItem: Object = this._getUserItem();
        if (userItem == null) {
            userItem = {};
        }
        userItem[key] = value;
        this._saveUserItem(userItem);
    }

    getItem(key: LocalStorageKey): Object | null {
        const userItem = this._getUserItem();
        if (userItem == null) {
            return null;
        }
        return userItem[key] || null;
    }

    private _getUserItem(): Object | null {
        if (this._uuid == null) {
            return null;
        }
        const userItem = localStorage.getItem(this._uuid);
        if (userItem == null) {
            return null;
        }
        try {
            return JSON.parse(userItem);
        } catch (e) {
            return null;
        }
    }

    private _saveUserItem(userItem: Object): void {
        if (this._uuid == null) {
            return;
        }
        localStorage.setItem(this._uuid, JSON.stringify(userItem));
        this.localStorageSubject.next();
    }
}



// WEBPACK FOOTER //
// ./src/app/services/local-storage.service.ts